import type CK from '~/types/contentking';
import type GraphQL from '~/types/graphql';

import useAccountFeaturesAvailability from '~/hooks/useAccountFeaturesAvailability';
import useAccountFeaturesUsage from '~/hooks/useAccountFeaturesUsage';
import useAccountTariff from '~/hooks/useAccountTariff';
import useAllowedPlans from '~/hooks/useAllowedPlans';

import {
	getTariffPlans,
	isFeatureAvailable,
} from '~/model/universal';



function usePlanNecessaryForCurrentFeatures(
	accountId: CK.AccountId | null,
): GraphQL.AccountPlan | null {
	const accountFeaturesAvailability = useAccountFeaturesAvailability();
	const accountFeaturesUsage = useAccountFeaturesUsage(accountId);
	const accountTariff = useAccountTariff(accountId);
	const allowedPlans = useAllowedPlans(accountId);

	if (
		accountFeaturesAvailability === null
		|| accountFeaturesUsage === null
		|| accountTariff === null
		|| allowedPlans === null
	) {
		return null;
	}

	for (const plan of getTariffPlans(accountTariff).filter((plan) => allowedPlans.includes(plan))) {
		const doesPlanSupportAllUsedFeatures = accountFeaturesUsage.featuresUsage.every(
			({ featureAmount, featureName }) => isFeatureAvailable(
				accountFeaturesAvailability,
				accountTariff,
				plan,
				featureName,
				featureAmount,
			),
		);

		if (doesPlanSupportAllUsedFeatures) {
			return plan;
		}
	}

	return null;
}



export default usePlanNecessaryForCurrentFeatures;
